import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalComponent } from 'ng2-bs3-modal';

import { Topic } from '../shared/types/topic.type';
import { SubTopic } from '../shared/types/sub-topic.type';

import { TopicService } from '../shared/services/topic.service'
import { SubTopicService } from '../shared/services/sub-topic.service'
import { QuestionService } from '../shared/services/question.service'

import * as $ from 'jquery';

@Component({
  selector: 'word-import',
  templateUrl: './word-import.html',
  styleUrls: ['./word-import.css']
})

export class WordImportComponent {

  @ViewChild('invalidTopic')
  invalidTopic: BsModalComponent;

  @ViewChild('invalidSubTopic')
  invalidSubTopic: BsModalComponent;

  @ViewChild('invalidTopics')
  invalidTopics: BsModalComponent;

  public options: Object = null;

  content: string;
  topic: Topic;
  subTopic: SubTopic;
  contentObject: any;
  loading: boolean = false;
  erroring: boolean = false;
  dupe: boolean = false;

  topicList: any = [];
  subtopicList: any = [];
  selectedTopicId: number = null;
  selectedSubTopicId: number = null;
  createNewTopics: boolean = true;
  invalidLabel: string = "ERROR";
  invalidSubLabel: string = "ERROR";

  constructor(public _route: ActivatedRoute, public _router: Router, public _topicService: TopicService, public _subTopicService: SubTopicService, public _questionService: QuestionService) { }

  ngOnInit() {
    this.populateTopics();
  }

  import() {

    let self = this;
    this.loading = true;

    this.contentObject = this.processContent(this.content);

    this._topicService.getTopic(this.contentObject.TopicName).subscribe(topicExists => { //check if topic exists
      this._subTopicService.getSubTopic(this.contentObject.SubTopicName).subscribe(subtopicExists => {
        if (topicExists != null && subtopicExists != null) {
          self.contentObject.TopicId = topicExists.TopicId;
          self.contentObject.SubTopicId = subtopicExists.SubTopicId;
          self.finishImport();
        } else {
          self.loading = false;
          self.invalidLabel = self.contentObject.TopicName;
          self.invalidSubLabel = self.contentObject.SubTopicName;
          if (topicExists == null && subtopicExists == null) {
            self.openTopicsModal();
          } if (topicExists != null) {
            self.populateSubTopics(topicExists.TopicId);
            self.contentObject.TopicId = topicExists.TopicId;
            self.openSubTopicModal();
          } else if (subtopicExists != null) {
            self.contentObject.SubTopicId = subtopicExists.SubTopicId;
            self.openTopicModal();
          }
        }
      }, error => {
        self.loading = false;
        self.erroring = true;
      });
    }, error => {
      self.loading = false;
      self.erroring = true;
    });



  }

  processContent(content) {

    let self = this
    let contentObj = {}

    contentObj = this.contentImportObject()

    $(content).find('tr').each(function (index, trRow) {
      if ($(trRow).parents('table').parents('table').length == 0) {
        self.processTR(contentObj, trRow)
      }
    })

    return contentObj
  }

  processTR(contentObj, trRow) {

    let titleStr = ''
    let contentStr = ''
    let self = this

    $(trRow).find('td').each(function (index, tdItem) {

      if (index === 0) {
        titleStr = $(tdItem).find('p:first').html()
      }

      if (index === 1) {
        contentStr = self.cleanContent(tdItem)
      }

    })

    this.addToContentObj(contentObj, titleStr, contentStr)
  }

  addToContentObj(contentObj, title, content) {

    switch (title) {
      case '<strong>Market:</strong>':
      case 'Market:':
      case 'Market':
        contentObj.TypeId = this.setType(content)
        break

      case '<a name="OLE_LINK1"><strong>Topic:&nbsp;</strong></a>':
      case '<strong>Topic:</strong>':
      case '<strong>Topic:&nbsp;</strong>':
      case '<p><strong>Topic:</strong></p>':
      case '<p><a name="_Hlk503861170"><strong>Topic:</strong></a></p>':
      case 'Topic:':
      case 'Topic':
        contentObj.TopicName = this.cleanTopics(content)
        break

      case '<strong>Subtopic:</strong>':
      case 'Subtopic:':
      case 'Subtopic':
        contentObj.SubTopicName = this.cleanTopics(content)
        break

      case '<strong>Question:</strong>':
      case 'Question:':
      case 'Question':
        contentObj.Content = this.cleanTopics(content)
        break

      default:
        contentObj.QuestionContent.push({ StateName: title, StateAbbreviation: '', Content: content, class: 'default' })
        break
    }
  }

  contentImportObject() {
    return { TypeId: null, TopicId: 0, TopicName: '', SubTopicId: 0, SubTopicName: '', QuestionId: null, Content: '', QuestionContent: [] }
  }

  setType(contentData) {

    switch (contentData) {
      case 'Both':
        return 3
      case 'Safety':
        return 1
      case 'Enviro':
        return 2
      default:
        return ''
    }

  }

  cleanTopics(contentData) {
    contentData = contentData.replace('<p>', '')
    contentData = contentData.replace('</p>', '')
    contentData = contentData.replace(new RegExp('&nbsp;', 'g'), '')
    contentData = contentData.trim();
    return contentData;
  }

  cleanContent(contentData) {
    let returnData = ''

    $(contentData).find('p,ul,ol,table').each(function (index, pItem) {
      if ($(pItem).parents('ul').length == 0) {
        if (!($(pItem).parents('table').length > 1)) {
          if ($(pItem).is('table')) {
            returnData = returnData + '<table border="1" cellpadding="0" cellspacing="0" style="width: 100%;">' + $(pItem).removeAttr('style').html() + '</table>'
          }
          else if ($(pItem).is('ul')) {
            returnData = returnData + '<ul>' + $(pItem).removeAttr('style').html() + '</ul>'
          }
          else {
            returnData = returnData + $(pItem).removeAttr('style').html()
          }
        }
      }
    })

    returnData = returnData.replace(new RegExp('<br>', 'g'), '</p><p>')

    returnData = returnData.replace(new RegExp('&nbsp;', 'g'), ' ')

    //returnData = returnData.replace(new RegExp('"', 'g'), '')

    return returnData;
  }

  openTopicModal() {
    this.invalidTopic.open();
  }
  openSubTopicModal() {
    this.invalidSubTopic.open();
  }
  openTopicsModal() {
    this.invalidTopics.open();
  }
  populateTopics() {
    let self = this;
    this._topicService.getTopics().subscribe(result => {
      self.topicList = result;
      self.populateSubTopics(self.topicList[0].TopicId);
    });
  }
  populateSubTopics(topicId) {
    let self = this;
    console.log("topic id: " + topicId);
    self._subTopicService.getSubTopicsByTopicId(topicId).subscribe(subtopics => {
      self.subtopicList = subtopics;
      this.selectedSubTopicId = null;
      /*if(self.subtopicList.length > 0){
        this.selectedSubTopicId = self.subtopicList[0].SubTopicId;
      }*/
    });
  }
  onTopicSelect(topicId) {

    this.selectedTopicId = topicId;
    this.selectedSubTopicId = null;
    this.populateSubTopics(topicId);
  }

  onSubTopicSelect(subTopicId) {
    this.selectedSubTopicId = subTopicId;
  }

  getTopicFromList(topicId) {
    for (let i = 0; i < this.topicList.length; i++) {
      if (this.topicList[i].TopicId == topicId) {
        return this.topicList[i];
      }
    }
    return null;
  }
  getSubtopicFromList(subtopicId) {
    for (let i = 0; i < this.subtopicList.length; i++) {
      if (this.subtopicList[i].SubTopicId == subtopicId) {
        return this.subtopicList[i];
      }
    }
    return null;
  }

  selectTopicAndImport() {
    this.contentObject.TopicId = this.selectedTopicId;
    this.contentObject.TopicName = this.getTopicFromList(this.selectedTopicId).TopicName;
    console.log("selected topic " + this.contentObject.TopicId + ": " + this.contentObject.TopicName);
    this.invalidTopic.dismiss();
    this.finishImport();
  }
  selectSubtopicAndImport() {
    this.contentObject.SubTopicId = this.selectedSubTopicId;
    this.contentObject.SubTopicName = this.getSubtopicFromList(this.selectedSubTopicId).SubTopicName;
    console.log("selected subtopic " + this.contentObject.SubTopicId + ": " + this.contentObject.SubTopicName);
    this.invalidSubTopic.dismiss();
    this.finishImport();
  }
  selectBothAndImport() {
    this.contentObject.TopicId = this.selectedTopicId;
    this.contentObject.TopicName = this.getTopicFromList(this.selectedTopicId).TopicName;
    this.contentObject.SubTopicId = this.selectedSubTopicId;
    this.contentObject.SubTopicName = this.getSubtopicFromList(this.selectedSubTopicId).SubTopicName;
    console.log("selected topic " + this.contentObject.TopicId + ": " + this.contentObject.TopicName);
    console.log("selected subtopic " + this.contentObject.SubTopicId + ": " + this.contentObject.SubTopicName);
    console.log("about to import");
    this.invalidTopics.dismiss();
    this.finishImport();
  }

  addTopicAndImport() {
    let self = this;
    let topic = new Topic;
    topic.TopicName = this.invalidLabel;

    this.invalidTopic.dismiss();
    this.loading = true;
    this._topicService.postTopic(topic).subscribe(data => {
      self.contentObject.TopicId = data.TopicId;
      self.finishImport();
    }, error => {
      self.loading = false;
      self.erroring = true;
    });
  }
  addSubTopicAndImport() {
    let self = this;
    let stopic = new SubTopic;
    stopic.SubTopicName = this.invalidSubLabel;

    this.invalidSubTopic.dismiss();
    this.loading = true;
    this._subTopicService.postSubTopic(stopic).subscribe(data => {
      self.contentObject.SubTopicId = data.SubTopicId;
      self.finishImport();
    }, error => {
      self.loading = false;
      self.erroring = true;
    });
  }
  addBothAndImport() {
    let self = this;
    let topic = new Topic;
    topic.TopicName = this.invalidLabel;
    let stopic = new SubTopic;
    stopic.SubTopicName = this.invalidSubLabel;

    this.invalidTopics.dismiss();
    this.loading = true;
    this._topicService.postTopic(topic).subscribe(tdata => {
      self.contentObject.TopicId = tdata.TopicId;
      self._subTopicService.postSubTopic(stopic).subscribe(sdata => {
        self.contentObject.SubTopicId = sdata.SubTopicId;
        self.finishImport();
      }, error => {
        self.loading = false;
        self.erroring = true;
      });
    }, error => {
      self.loading = false;
      self.erroring = true;
    })
  }

  finishImport() {
    let self = this;
    self.loading = true;
    self.erroring = false;
    self.dupe = false;
    self._questionService.getQuestionsBySubTopicId(self.contentObject.TopicId, self.contentObject.SubTopicId).subscribe(questions => {
      for (let i = 0; i < questions.length; i++) {
        if (questions[i].Content.toLowerCase() == self.contentObject.Content.toLowerCase()) {
          self.dupe = true;
          self.loading = false;
          break;
        }
      }
      if (!(self.dupe)) {
        self._questionService.postQuestion(self.contentObject).subscribe(data => {

          self._router.navigate(["/questions/" + data.QuestionId + "/" + data.TopicId + "/" + data.SubTopicId]);

        }, error => {
          self.loading = false;
          self.erroring = true;
        });
      }
    });

  }
}
